// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-external-stats-modal__container {
    margin: 18px 0;
    padding: 0 40px;
}

.profile-external-stats-modal__form .input-field-label, 
.profile-external-stats-modal__form .select-field-label{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));/* 14px */;
    color: var(--primary-very-dark-color);
}

.profile-external-stats-modal__form .input-field-input,
.profile-external-stats-modal__form .select-field-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
}

.profile-external-stats-modal__form .disabled .input-field-input,
.profile-external-stats-modal__form .disabled .select-field-input {
    opacity: 50%;
}

.profile-external-stats-modal__form .MuiSelect-select.MuiInputBase-input.MuiInput-input:focus {
    background-color: transparent;
}

.profile-external-stats-modal__form-dates {
    display: flex;
    align-items: center;
    gap: 45px;
    justify-content: center;
}

.profile-external-stats-modal__form-dates__date.input-field {
    width: 100%;
    margin-top: 20px;
}

.profile-external-stats-modal__form .input-field {
    margin-bottom: 0;
}

.profile-external-stats-modal__tournament-name.input-field {
    margin-top: 20px;
}

.profile-external-stats-modal__center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-external-stats-modal__info-msg {
    display: flex;
    align-items: center;
    margin-top: 4px;
}

.profile-external-stats-modal__info-msg .hubicon-info {
    font-size: 14px;
    margin-right: 4px;
    color:  var( --new-informative-banner-bg-color);
}

.profile-external-stats-modal__info-msg .hubicon-info::before {
    color:  var( --new-informative-banner-color);
}


.profile-external-stats-modal__url .input-field-input {
    margin-bottom: 0;
}

.profile-external-stats-modal__tournament-logo {
    padding: 0;
    margin: 0 auto;
    position: relative;
    display: flex;
    overflow: hidden;
    width: calc(calc(var(--space-x3) * 2) + var(--space-quarter));
    height: calc(calc(var(--space-x3) * 2) + var(--space-quarter));
    justify-content: center;
    align-items: center;
}

.profile-external-stats-modal__tournament-logo .icon-trophy {
    font-size: 50px;
    background-color: var(--new-icon-color);
    padding: 10px;
    color: var(--white-color);
    border-radius: 50%;
}

.profile-external-stats-modal__tournament-logo img{
    border-radius: 50%;
    width: 70px;
    height: 70px;
}

.profile-external-stats-modal__new-button {
    position: absolute;
    width: var(--space-and-half);
    height: var(--space-and-half);
    right: var(--space-half);
    top: 65%;
    right: 10%;
    cursor: pointer;
    color: var(--white-color);
    background-color: var(--new-green-color);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-external-stats-modal__new-button.disabled {
    opacity: 70%;
    cursor: default;
}

.profile-external-stats-modal__image-msg.baloa-table-column{
    color: var(--new-green-color);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
    cursor: pointer;
}

.profile-external-stats-modal__image-msg.disabled {
    opacity: 70%;
    cursor: default;
}

.profile-external-stats-modal__select {
    margin-top: 40px;
}

.profile-external-stats-modal__select .select-field__message{
    position: relative;
}

.input-field.profile-external-stats-modal__url {
    margin-top: 20px;
}

.profile-external-stats-modal__actions {
    border-top: 1px solid var(--new-gray-background-color);
    padding: 16px;
    display: flex;
}

.profile-external-stats-modal__actions .primary-button{
    margin-left: auto;
}

.profile-external-stats-modal__actions .text-button {
    color: var(--error-color);
}

@media screen and (min-width: 992px){
    .profile-external-stats-modal .modal2__container {
        width: 40%;
    }
}

@media screen and (max-width: 992px){
    .profile-external-stats-modal .modal2__container {
        width: 60%;
    }
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .profile-external-stats-modal .modal2__container{
        margin: 0;
        border-radius: 0;
        height: 100%;
        max-height: 100%;
        width: 100%;
    }

    .profile-external-stats-modal .modal2__header {
        padding-bottom: 12px;
    }

    .profile-external-stats-modal__tournament-logo {
        width: 100px;
        height: 100px;
    }

    .profile-external-stats-modal__container {
        padding: 0 16px;
        margin: 18px 0 0 0;
    }

    .profile-external-stats-modal__form-dates.mobile {
        flex-direction: column;
        gap: 0;
    }

    .profile-external-stats-modal__actions {
        padding: 12px 16px;
    }
    
    .profile-external-stats-modal__actions .primary-button{
        width: 100%;
    }

    .profile-external-stats-modal__form .text-button {
        color: var(--error-color);
        margin: 12px auto;
    }

    .profile-external-stats-modal__info-msg {
        margin-bottom: 10px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-external-stats-modal/ProfileExternalStatsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,gEAAgE,CAAC,SAAS;IAC1E,qCAAqC;AACzC;;AAEA;;IAEI,oCAAoC;IACpC,kDAAkD;AACtD;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,4CAA4C;AAChD;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,6DAA6D;IAC7D,8DAA8D;IAC9D,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uCAAuC;IACvC,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,wBAAwB;IACxB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sDAAsD;IACtD,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,SAAS;QACT,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,MAAM;IACV;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".profile-external-stats-modal__container {\n    margin: 18px 0;\n    padding: 0 40px;\n}\n\n.profile-external-stats-modal__form .input-field-label, \n.profile-external-stats-modal__form .select-field-label{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));/* 14px */;\n    color: var(--primary-very-dark-color);\n}\n\n.profile-external-stats-modal__form .input-field-input,\n.profile-external-stats-modal__form .select-field-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.profile-external-stats-modal__form .disabled .input-field-input,\n.profile-external-stats-modal__form .disabled .select-field-input {\n    opacity: 50%;\n}\n\n.profile-external-stats-modal__form .MuiSelect-select.MuiInputBase-input.MuiInput-input:focus {\n    background-color: transparent;\n}\n\n.profile-external-stats-modal__form-dates {\n    display: flex;\n    align-items: center;\n    gap: 45px;\n    justify-content: center;\n}\n\n.profile-external-stats-modal__form-dates__date.input-field {\n    width: 100%;\n    margin-top: 20px;\n}\n\n.profile-external-stats-modal__form .input-field {\n    margin-bottom: 0;\n}\n\n.profile-external-stats-modal__tournament-name.input-field {\n    margin-top: 20px;\n}\n\n.profile-external-stats-modal__center {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.profile-external-stats-modal__info-msg {\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n}\n\n.profile-external-stats-modal__info-msg .hubicon-info {\n    font-size: 14px;\n    margin-right: 4px;\n    color:  var( --new-informative-banner-bg-color);\n}\n\n.profile-external-stats-modal__info-msg .hubicon-info::before {\n    color:  var( --new-informative-banner-color);\n}\n\n\n.profile-external-stats-modal__url .input-field-input {\n    margin-bottom: 0;\n}\n\n.profile-external-stats-modal__tournament-logo {\n    padding: 0;\n    margin: 0 auto;\n    position: relative;\n    display: flex;\n    overflow: hidden;\n    width: calc(calc(var(--space-x3) * 2) + var(--space-quarter));\n    height: calc(calc(var(--space-x3) * 2) + var(--space-quarter));\n    justify-content: center;\n    align-items: center;\n}\n\n.profile-external-stats-modal__tournament-logo .icon-trophy {\n    font-size: 50px;\n    background-color: var(--new-icon-color);\n    padding: 10px;\n    color: var(--white-color);\n    border-radius: 50%;\n}\n\n.profile-external-stats-modal__tournament-logo img{\n    border-radius: 50%;\n    width: 70px;\n    height: 70px;\n}\n\n.profile-external-stats-modal__new-button {\n    position: absolute;\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    right: var(--space-half);\n    top: 65%;\n    right: 10%;\n    cursor: pointer;\n    color: var(--white-color);\n    background-color: var(--new-green-color);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.profile-external-stats-modal__new-button.disabled {\n    opacity: 70%;\n    cursor: default;\n}\n\n.profile-external-stats-modal__image-msg.baloa-table-column{\n    color: var(--new-green-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 40px;\n    cursor: pointer;\n}\n\n.profile-external-stats-modal__image-msg.disabled {\n    opacity: 70%;\n    cursor: default;\n}\n\n.profile-external-stats-modal__select {\n    margin-top: 40px;\n}\n\n.profile-external-stats-modal__select .select-field__message{\n    position: relative;\n}\n\n.input-field.profile-external-stats-modal__url {\n    margin-top: 20px;\n}\n\n.profile-external-stats-modal__actions {\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 16px;\n    display: flex;\n}\n\n.profile-external-stats-modal__actions .primary-button{\n    margin-left: auto;\n}\n\n.profile-external-stats-modal__actions .text-button {\n    color: var(--error-color);\n}\n\n@media screen and (min-width: 992px){\n    .profile-external-stats-modal .modal2__container {\n        width: 40%;\n    }\n}\n\n@media screen and (max-width: 992px){\n    .profile-external-stats-modal .modal2__container {\n        width: 60%;\n    }\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .profile-external-stats-modal .modal2__container{\n        margin: 0;\n        border-radius: 0;\n        height: 100%;\n        max-height: 100%;\n        width: 100%;\n    }\n\n    .profile-external-stats-modal .modal2__header {\n        padding-bottom: 12px;\n    }\n\n    .profile-external-stats-modal__tournament-logo {\n        width: 100px;\n        height: 100px;\n    }\n\n    .profile-external-stats-modal__container {\n        padding: 0 16px;\n        margin: 18px 0 0 0;\n    }\n\n    .profile-external-stats-modal__form-dates.mobile {\n        flex-direction: column;\n        gap: 0;\n    }\n\n    .profile-external-stats-modal__actions {\n        padding: 12px 16px;\n    }\n    \n    .profile-external-stats-modal__actions .primary-button{\n        width: 100%;\n    }\n\n    .profile-external-stats-modal__form .text-button {\n        color: var(--error-color);\n        margin: 12px auto;\n    }\n\n    .profile-external-stats-modal__info-msg {\n        margin-bottom: 10px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
